var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("大事记")]),(_vm.associationData)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.associationData.content)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }